import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import StepConnector from '@material-ui/core/StepConnector';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import useWizardSteps from '../../hooks/useWizardSteps';
import './style.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepIcon: {
    fill: '#FFF',
    width: '36px',
    height: '36px',
    boxShadow: '-1px 8px 30px rgba(0, 73, 135, 0.15)',
    borderRadius: '50%',
  },
  completed: {
    fill: '#C1D42F',
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  active: {
    fill: '#C1D42F',
    '& $text': {
      fill: '#FFF',
    },
  },
  text: {
    fill: '#C1D42F',
  },
}));

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 15,
  },
  active: {
    '& $line': {
      borderColor: '#C1D42F',
      borderStyle: 'solid',
      backgroundColor: '#C1D42F',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#C1D42F',
      borderStyle: 'solid',
      backgroundColor: '#C1D42F',
    },
  },
  disabled: {
    '& $line': {
      borderColor: '#004987',
    },
  },
  line: {
    borderStyle: 'dashed',
    borderColor: '#eaeaf0',
    borderTopWidth: 2,
    borderBottomWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
  },
})(StepConnector);

export default function HorizontalStepper(props) {
  const classes = useStyles();
  const { activeStep } = props;
  const [, steps] = useWizardSteps();
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      classes={{ root: classes.root }}
      style={{ backgroundColor: 'transparent' }}
      connector={<QontoConnector />}>
      {steps.map((label, num) => (
        <Step key={label}>
          <StepLabel
            StepIconProps={{
              classes: {
                root: classes.stepIcon,
                completed: classes.completed,
                text: classes.text,
                active: classes.active,
              },
            }}>
            <span>{label}</span>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
